<template>
    <v-dialog v-model="dialog" max-width="500px">

        <template v-slot:activator="{ on }">
            <v-btn small icon class="grey--text" @click="chooseOptions(gameId)" v-on="on">
                <v-icon small color="indigo">mdi-pencil</v-icon>
            </v-btn>
        </template>

        <!-- When both results are empty -->
        <v-card flat v-if="bothEmpty">
            <!-- opponent details -->
            <v-row justify="center" align="center">
                <v-col cols="7">
                    <v-responsive class="pt-4 text-center">
                        <span class="title blue-grey--text font-italic mr-5">VS</span>
                        <v-avatar size="70">
                            <v-img :src="opponent.avatar"></v-img>
                        </v-avatar>
                    </v-responsive>
                </v-col>
                <v-col cols="5" class="pt-7">
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>{{ opponent.name }}</v-list-item-title>
                                <v-list-item-subtitle>{{ opponent.alias }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>                   
                </v-col>
            </v-row>
            <v-card-title class="mb-5 font-italic blue-grey lighten-4">{{ momentjs(game.timeStamp) }}</v-card-title>
            <v-card-text class="mb-5">위 플레이어와의 게임에서...</v-card-text>
            <v-card-text>
                <v-radio-group v-model="userTempResult" row class="justify-space-around">
                    <v-radio label="이겼어요!" value="win"></v-radio>
                    <v-radio label="졌어요!" value="lose"></v-radio>
                </v-radio-group>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" dark color="blue-grey" class="mb-2" @click="updatingResult(gameId)">제출</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>

        <!-- Either result is empty -->
        <v-card flat v-if="eitherEmpty">
            <!-- opponent details -->
            <v-row justify="center" align="center" v-if="opponent">
                <v-col cols="7">
                    <v-responsive class="pt-4 text-center">
                        <span class="title blue-grey--text font-italic mr-5">VS</span>
                        <v-avatar size="70">
                            <v-img :src="opponent.avatar"></v-img>
                        </v-avatar>
                    </v-responsive>
                </v-col>
                <v-col cols="5" class="pt-7">
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>{{ opponent.name }}</v-list-item-title>
                                <v-list-item-subtitle>{{ opponent.alias }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>                   
                </v-col>
            </v-row>
            <v-card-title class="mb-5 font-italic blue-grey lighten-4">{{ momentjs(game.timeStamp) }}</v-card-title>
            <v-card-text>
                <v-row v-if="acceptingResult">
                    <h4 class="body-2 grey--text">
                        <span>
                            위 플레이어가
                            <span class="indigo--text body-1">
                                "{{ opponentTempResult }}"
                            </span> (이)라는데, 당신이
                            <span class="pink--text body-1">
                                "{{ reversingResult(opponentTempResult) }}"
                            </span> 맞습니까?
                        </span>
                    </h4>
                </v-row>

                <!-- user is modifying the result -->
                <v-row v-if="modifyingResult">
                    <h4 class="body-2 grey--text">
                        <span>
                            위 플레이어와의 게임에서
                            <span class="indigo--text body-1">
                                "{{ userTempResult }}"
                            </span>(이)라고 입력했는데,
                            <span class="pink--text body-1">
                                "{{ reversingResult(userTempResult) }}"
                            </span>(으)로 바꾸시겠습니까? 
                        </span>
                    </h4>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn :loading="loading" v-if="modifyingResult" small dark class="mb-2 mx-auto" color="blue-grey" @click.once="modifying(gameId)">고치기</v-btn>
                <v-btn :loading="loading" v-if="acceptingResult" small dark class="mb-2 mx-auto" color="blue-grey" @click.once="accepting(gameId)">맞아요!</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
    
</template>

<script>
import db from '@/fb'
import slugify from 'slugify'
import firebase from 'firebase/app'
import 'firebase/auth'
import moment from 'moment'

export default {
    name: 'Confirm',
    props: [ 'gameId', 'groupId' ],
    data: () => ({
        dialog: false,
        loading: false,
        userTempResult: null,
        opponentTempResult: null,
        user: null,
        opponent: null,
        userId: null,
        opponentId: null,
        bothEmpty: false,
        eitherEmpty: false,
        game: null,
        userPosition: null,        
        modifyingResult: false,
        acceptingResult: false,
        ratingChart: [
            { min: 0, max: 12, expectedResult: 8, upsetResult: 8, compensation: 0},
            { min: 13, max: 37, expectedResult: 7, upsetResult: 10, compensation: 1},
            { min: 38, max: 62, expectedResult: 6, upsetResult: 13, compensation: 1},
            { min: 63, max: 87, expectedResult: 5, upsetResult: 16, compensation: 2},
            { min: 88, max: 112, expectedResult: 4, upsetResult: 20, compensation: 2},
            { min: 113, max: 137, expectedResult: 3, upsetResult: 25, compensation: 3},
            { min: 138, max: 162, expectedResult: 2, upsetResult: 30, compensation: 4},
            { min: 163, max: 187, expectedResult: 2, upsetResult: 35, compensation: 5},
            { min: 188, max: 212, expectedResult: 1, upsetResult: 40, compensation: 6},
            { min: 213, max: 237, expectedResult: 1, upsetResult: 45, compensation: 7},
            { min: 238, max: 2000, expectedResult: 0, upsetResult: 50, compensation: 8}
        ],
        levelRating: [
            { level: 0, ratingMin: 1900, ratingMax: 3000 },
            { level: 1, ratingMin: 1840, ratingMax: 1899 },
            { level: 2, ratingMin: 1780, ratingMax: 1839 },
            { level: 3, ratingMin: 1720, ratingMax: 1779 },
            { level: 4, ratingMin: 1640, ratingMax: 1719 },
            { level: 5, ratingMin: 1500, ratingMax: 1639 },
            { level: 6, ratingMin: 1300, ratingMax: 1499 },
            { level: 7, ratingMin: 1100, ratingMax: 1299 },
            { level: 8, ratingMin: 900, ratingMax: 1099 },
            { level: 9, ratingMin: 800, ratingMax: 899 },
            { level: 10, ratingMin: 700, ratingMax: 799 }
        ]        
    }),
    created(){
        // get current user
        let user = firebase.auth().currentUser;

        // find the user record
        if(user){
            db.collection('users').where('user_id', '==', user.uid).get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        this.user = {
                            ...doc.data(),
                            id: doc.id
                        };
                    })
                }).then(() => {
                    this.userId = this.user.id
                })
        } else {
            return false
        }
    },
    methods: {
        chooseOptions(id){

            // get the game info and store the variable 'game'
            db.collection('games').doc(id).get().then(doc => {
                this.game = doc.data();
            }).then(() => {

                // find out the opponent's id
                if(this.user.alias == this.game.playerOne.alias){
                    this.opponentId = slugify(this.game.playerTwo.alias, {
                        replacement: '-',
                        remove: /[$*_+~.()'"!\-:@]/g,
                        lower: true
                    });
                } else {
                    this.opponentId = slugify(this.game.playerOne.alias, {
                        replacement: '-',
                        remove: /[$*_+~.()'"!\-:@]/g,
                        lower: true
                    });
                }

                // get the opponent from db
                db.collection('users').doc(this.opponentId).get().then(opponent => {
                    this.opponent = opponent.data();
                }).then(() => {
                    // when both the results are empty
                    if(this.game.playerOne.result == null && this.game.playerTwo.result == null) {                       
                        // updating("user -null : opponent - null")
                        this.bothEmpty = true;

                        // find out the position of the user
                        if(this.user.alias == this.game.playerOne.alias){
                            this.userPosition = 'left';
                        } else {
                            this.userPosition = 'right';
                        }                    
                    } else {
                        // when either is empty
                        this.eitherEmpty = true;

                        if(this.user.alias == this.game.playerOne.alias && this.game.playerOne.result == 'win'){
                            // modifying(user - win : opponent - null)
                            this.userTempResult = 'win';
                            this.userPosition = 'left';
                            this.modifyingResult = true;
                        } else if(this.user.alias == this.game.playerOne.alias && this.game.playerOne.result == 'lose'){
                            // modifying(user - lose : opponent - null)
                            this.userTempResult = 'lose';
                            this.userPosition = 'left';
                            this.modifyingResult = true;
                        }else if(this.user.alias == this.game.playerOne.alias && this.game.playerTwo.result == 'win'){
                            // accepting(user - null : opponent - win)
                            this.opponentTempResult = 'win';
                            this.userPosition = 'left';
                            this.acceptingResult = true;
                        } else if(this.user.alias == this.game.playerOne.alias && this.game.playerTwo.result == 'lose'){
                            // accepting(user - null : opponent - lose)                                
                            this.opponentTempResult = 'lose'
                            this.userPosition = 'left';
                            this.acceptingResult = true; 
                        } else if(this.user.alias == this.game.playerTwo.alias && this.game.playerTwo.result == "win"){
                            // modifying(opponent - null : user - win)
                            this.userTempResult = 'win';
                            this.userPosition = 'right';
                            this.modifyingResult = true;
                        } else if(this.user.alias == this.game.playerTwo.alias && this.game.playerTwo.result == "lose"){
                            // modifying(opponent - null : user - lose)
                            this.userTempResult = 'lose';
                            this.userPosition = 'right';
                            this.modifyingResult = true;
                        } else if(this.user.alias == this.game.playerTwo.alias && this.game.playerOne.result == "win"){
                            // accepting(opponent - win : user - null)                                
                            this.opponentTempResult = 'win'
                            this.userPosition = 'right';
                            this.acceptingResult = true;
                        } else if(this.user.alias == this.game.playerTwo.alias && this.game.playerOne.result == "lose"){
                            // accepting(opponent - lose : user - null)                                
                            this.opponentTempResult = 'lose'
                            this.userPosition = 'right';
                            this.acceptingResult = true;
                        }
                    }
                })
            })
        },
        updatingResult(id){
            this.loading = true;
            // check if the opponent has alread checked the result
            db.collection('games').doc(id).get().then(doc => {
                let game = doc.data()
                if(this.userTempResult != null && game.playerOne.result == null && game.playerTwo.result == null){
                    if(this.user.alias == this.game.playerOne.alias){
                        this.game.playerOne.result = this.userTempResult;
                    } else {
                        this.game.playerTwo.result = this.userTempResult;
                    }
                    // update the result of the game into db
                    db.collection('games').doc(id).update(this.game).then(() => {
                        this.bothEmpty = false;
                        this.dialog = false;
                        this.loading = false;
                    })
                } else {
                    this.bothEmpty = false;
                    this.loading = false;
                    this.dialog = false;
                    return false
                }
            })          
        },
        modifying(id){
            this.loading = true;
            // check if the opponent has alread checked the result
            db.collection('games').doc(id).get().then(doc => {
                let game = doc.data()
                if(game.playerOne.result != null || game.playerTwo.result != null){
                    this.bothEmpty = false;

                    // change the value of the user's result
                    if(this.userPosition == 'left'){
                        this.game.playerOne.result = this.reversingResult(this.userTempResult)
                        this.game.timeStamp = Date.now();
                    } else {
                        this.game.playerTwo.result = this.reversingResult(this.userTempResult)
                        this.game.timeStamp = Date.now();
                    }
                    
                    // update the result of the game into db
                    db.collection('games').doc(id).update(this.game).then(() => {
                        this.dialog = false;
                        this.loading = false;
                    })
                } else {
                    this.loading = false;
                    this.dialog = false;
                    return false
                }
            })          
        },
        accepting(id){
            this.loading = true;
            
            // get the user info
            db.collection('users').doc(this.userId).get()
                .then(user => {
                    this.user = user.data();
            }).then(() => {
                // get the opponent info
                db.collection('users').doc(this.opponentId).get()
                    .then(opponent => {
                        this.opponent = opponent.data();
                    })
            }).then(() => {

                // find out the position of the group in both the user and the opponent
                let groupPositionInUser = null;
                let groupPositionInOpponent = null;

                this.user.joinedGroups.forEach((group, index) => {
                    if(group.id == this.groupId){
                        groupPositionInUser = index
                    }
                })
                this.opponent.joinedGroups.forEach((group, index) => {
                    if(group.id == this.groupId){
                        groupPositionInOpponent = index;
                    }
                })

                // game finished
                this.game.finished = true;
                this.user.inGame = false;
                this.opponent.inGame = false;

                // update both this.game and (the user and the opponent)

                // When the user is on the left side(user - null : opponent - win/lose)           
                if(this.userPosition == 'left'){
                    // console.log('the user is on the left')
                    this.game.playerOne.result = this.reversingResult(this.game.playerTwo.result)

                    this.game.playerOne.level = this.user.level;
                    this.game.playerOne.total = this.user.total;
                    this.game.playerOne.wins = this.user.wins;
                    this.game.playerOne.loses = this.user.loses;

                    this.game.playerTwo.level = this.opponent.level;
                    this.game.playerTwo.total = this.opponent.total;
                    this.game.playerTwo.wins = this.opponent.wins;
                    this.game.playerTwo.loses = this.opponent.loses;

                    let gainLosePoints = this.spinOutPoints(this.game.playerOne.result);
                    
                    if(this.game.playerTwo.result == 'win'){
                        // user - null : opponent - win                   
                        this.game.playerOne.points = -gainLosePoints;                                       
                        this.game.playerTwo.points = gainLosePoints;                     
                        this.game.winner.alias = this.opponent.alias;
                        this.game.winner.name = this.opponent.name;
                        this.game.loser.alias = this.user.alias;                    
                        this.game.loser.name = this.user.name;
                        
                        // update both the user and the opponent
                        this.user.total += -gainLosePoints;
                        this.user.joinedGroups[groupPositionInUser].history.push(this.user.total)
                        this.user.history.push(this.user.total)
                        this.user.loses += 1;
                        this.user.level = this.adjustingLevel(this.user.total);
                        this.opponent.joinedGroups[groupPositionInOpponent].history.push(this.opponent.total)
                        this.opponent.history.push(this.opponent.total)
                        this.opponent.total += gainLosePoints;
                        this.opponent.wins += 1;
                        this.opponent.level = this.adjustingLevel(this.opponent.total);
                    } else {
                        // user - null : opponent - lose
                        this.game.playerOne.points = gainLosePoints;                  
                        this.game.playerTwo.points = -gainLosePoints;
                        this.game.winner.alias = this.user.alias;
                        this.game.winner.name = this.user.name;
                        this.game.loser.alias = this.opponent.alias;                    
                        this.game.loser.name = this.opponent.name;

                        // update both the user and the opponent
                        this.user.total += gainLosePoints;
                        this.user.joinedGroups[groupPositionInUser].history.push(this.user.total)
                        this.user.history.push(this.user.total)
                        this.user.wins += 1;
                        this.user.level = this.adjustingLevel(this.user.total);
                        this.opponent.total -= gainLosePoints;
                        this.opponent.joinedGroups[groupPositionInOpponent].history.totals.push(this.opponent.total)
                        this.opponent.history.push(this.opponent.total)
                        this.opponent.loses += 1;
                        this.opponent.level = this.adjustingLevel(this.opponent.total);
                    }
                
                // When the user is on the right side(opponent - win/lose : user - null)
                } else if(this.userPosition == 'right') {
                    this.game.playerTwo.result = this.reversingResult(this.game.playerOne.result)

                    this.game.playerOne.level = this.opponent.level;
                    this.game.playerOne.total = this.opponent.total;
                    this.game.playerOne.wins = this.opponent.wins;
                    this.game.playerOne.loses = this.opponent.loses;

                    this.game.playerTwo.level = this.user.level;
                    this.game.playerTwo.total = this.user.total;
                    this.game.playerTwo.wins = this.user.wins;
                    this.game.playerTwo.loses = this.user.loses;

                    let gainLosePoints = this.spinOutPoints(this.game.playerTwo.result);

                    if(this.game.playerOne.result == 'win'){
                        // opponent - win : user - null
                        this.game.playerOne.points = gainLosePoints;                                       
                        this.game.playerTwo.points = -gainLosePoints;                     
                        this.game.winner.alias = this.opponent.alias;
                        this.game.winner.name = this.opponent.name;
                        this.game.loser.alias = this.user.alias;                    
                        this.game.loser.name = this.user.name;
                        
                        // update both the user and the opponent
                        this.user.total += -gainLosePoints;
                        this.user.joinedGroups[groupPositionInUser].history.push(this.user.total)
                        this.user.history.push(this.user.total)
                        this.user.loses += 1;
                        this.user.level = this.adjustingLevel(this.user.total);
                        this.opponent.total += gainLosePoints;
                        this.opponent.joinedGroups[groupPositionInOpponent].history.push(this.opponent.total)
                        this.opponent.history.push(this.opponent.total)
                        this.opponent.wins += 1;
                        this.opponent.level = this.adjustingLevel(this.opponent.total);

                    } else {
                        // opponent - lose : user - null
                        this.game.playerOne.points = -gainLosePoints;                  
                        this.game.playerTwo.points = gainLosePoints;
                        this.game.winner.alias = this.user.alias;
                        this.game.winner.name = this.user.name;
                        this.game.loser.alias = this.opponent.alias;                    
                        this.game.loser.name = this.opponent.name;

                        // update both the user and the opponent
                        this.user.total += gainLosePoints;
                        this.user.joinedGroups[groupPositionInUser].history.push(this.user.total)
                        this.user.history.push(this.user.total)
                        this.user.wins += 1;
                        this.user.level = this.adjustingLevel(this.user.total);
                        this.opponent.total -= gainLosePoints;
                        this.opponent.joinedGroups[groupPositionInOpponent].history.push(this.opponent.total)
                        this.opponent.history.push(this.opponent.total)
                        this.opponent.loses += 1;
                        this.opponent.level = this.adjustingLevel(this.opponent.total);
                    }
                }
            }).then(() => {

                // update the result of the game into db
                db.collection('games').doc(id).update(this.game)
                    .then(() => {
                        // console.log("the game updated", this.game)
                    })
                // update both the user into db
                db.collection('users').doc(this.userId).update(this.user)
            
                // update both the opponent into db
                db.collection('users').doc(this.opponentId).update(this.opponent)
                    .then(() => {
                        this.dialog = false;
                        this.loading = false;
                        // this.$router.push({ name: 'MyPage' })
                        // location.reload();
                    })
            })         
        },
        adjustingLevel(newTotal){
            // console.log(newTotal)
            let newLevel = null;
            this.levelRating.forEach(item => {
                if(newTotal >= item.ratingMin && newTotal <= item.ratingMax){
                   newLevel = item.level;
                }
            });
            return newLevel;
        },
        reversingResult(result){
            if(result == 'win'){
                return 'lose'
            } else {
                return 'win'
            }
        },
        spinOutPoints(theUserResult){

            // console.log(this.user.total, this.opponent.total)

            let differenceOfTotality = Math.abs(this.user.total - this.opponent.total);
            let levelGap = Math.abs(this.user.level - this.opponent.level)
            let pointsGapOnStart = null;
            if(levelGap == 0){
                pointsGapOnStart = 0;
            } else if(levelGap == 1) {
                pointsGapOnStart = 2;
            } else {
                pointsGapOnStart = levelGap + 1;
            } 
            let criteria = null;
            this.ratingChart.forEach(item => {
                if(differenceOfTotality >= item.min && differenceOfTotality <= item.max){
                    criteria = item;
                }
            });
            // console.log(differenceOfTotality, levelGap, pointsGapOnStart, criteria)
            
            if(this.user.total > this.opponent.total){
                // user has higher rating and opponent has lower rating
                if(theUserResult == 'win'){
                    // When user with high total points wins the game
                    // console.log('when the user is higer than the opponent and wins the game')
                    // console.log(this.calculatingPoints(criteria, pointsGapOnStart, "expectedResult"))
                    return this.calculatingPoints(criteria, pointsGapOnStart, "expectedResult");
                } else {
                    // When user with high total points loses the game
                    // console.log('when the user is higer than the opponent and loses the game')
                    // console.log(this.calculatingPoints(criteria, pointsGapOnStart, "upsetResult"))
                    return this.calculatingPoints(criteria, pointsGapOnStart, "upsetResult");
                }
            } else if(this.user.total < this.opponent.total){
                // user is lower and opponent is higher
                if(theUserResult == 'win'){
                    // When user with low total points wins the game
                    // console.log('when the opponent is higher than the opponent and wins the game')
                    // console.log(this.calculatingPoints(criteria, pointsGapOnStart, "upsetResult"))                    
                    return this.calculatingPoints(criteria, pointsGapOnStart, "upsetResult");
                } else {
                    // When user with high total points loses the game
                    // console.log('when the opponent is higher than the opponent and loses the game')
                    // console.log(this.calculatingPoints(criteria, pointsGapOnStart, "expectedResult"))
                    return this.calculatingPoints(criteria, pointsGapOnStart, "expectedResult");
                }
            } else {
                // there is no difference of total points between user and opponent
                // console.log('when the user is the same as the opponent')
                // console.log(this.calculatingPoints(criteria, pointsGapOnStart, "expectedResult"))
                return this.calculatingPoints(criteria, pointsGapOnStart, "expectedResult")
            }
        },
        calculatingPoints(criteria, pointsGapOnStart, resultMode){
            // { min: 113, max: 137, expectedResult: 3, upsetResult: 25, compensation: 3}
            if(resultMode == "expectedResult"){
                // console.log(criteria.expectedResult)
                return criteria.expectedResult;
            } else if(resultMode == 'upsetResult') {
                // console.log(criteria.upsetResult, pointsGapOnStart, criteria.compensation)
                return criteria.upsetResult - (pointsGapOnStart * criteria.compensation);
            }
        },
        momentjs(timeStamp){
            return moment(timeStamp).calendar();
        } 

    }
}
</script>

<style>

</style>